// extracted by mini-css-extract-plugin
export default {"row":"editItem_row__kqwZA","col":"editItem_col__8OgKK","card":"editItem_card__v5XhP"};